import { Component, OnInit } from '@angular/core';
import { interval, Observable, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { ReservationsService } from 'src/app/services/reservations.service';

@Component({
  selector: 'app-header-dots',
  templateUrl: './header-dots.component.html'
})
export class HeaderDotsComponent implements OnInit {
  
   public notifications$: Observable<number>;
   public notifications = 0
   constructor(public notificationService: NotificationService,private reservationsService: ReservationsService,) {}

  // ngOnInit(){
  //      this.notifications$ = this.notificationService.notifications$
  //      this.getAllNotifs();
  // }

  // timeout;
  // ngOnDestroy() {
  //     // Clear the pending timeout so it doesn't keep running
  //   //  clearTimeout(this.timeout);
  // }

  getAllNotifs(){
    setTimeout(() => {

     }, 5000);
  }



  intervalSubscription: Subscription;
  source = interval(120000);

  //constructor() {}

  ngOnInit(): void {
      /*every 1second it emits value 0,1,2... 
      if we move to other component(destroy the component) it won't stop 
      incrementing and  another interval created along with the old 
      interval. Untill we unsubscribed it it 
      won't stop the incrementing process
      */
      this.intervalSubscription = this.source.subscribe(val =>{
        this.reservationsService.getGreetRequestList()
        .subscribe(
          (data:any) => {
            if(data['status']){
              this.notifications = data['result'][0].COUNT
            }else{
              this.notifications = 0; 
            }
          },
          error => {
            console.log(error);
          });
      } ); 
  }

  ngOnDestroy() {
      //when you move to another component, now the interval will be 
      //unsubscribed.
      //console.log('Destroying....');
      this.intervalSubscription.unsubscribe();
  }  







}
